import Section from '@/components/Section'
import Title from '@/components/Title'
import Container from '@/components/Container'
import React from 'react'
import Button from '@/components/Button'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { api } from '@/api'
import { Awards } from '@/interfaces/Awards'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import { dataStates } from '@garpix/fetcher'
import style from './styles/news.module.scss'
import AwardsCard from '@/components/Cards/AwardsCard'
import classNames from 'classnames'

const AwardsSection = (): React.ReactElement => {
  return (
    <Section>
      <Container>
        <Title type='h2' theme='h1' className={style.title}>
          Награды
        </Title>
        <FetcherList
          isScrollTop={false}
          isHistoryPush={false}
          initFilter={{ page_size: 2 }}
          api={api.getAwardsList}
        >
          {({
            results,
            showMore,
            status,
            isNext
          }: IFetcherListResults<Awards[]>) => {
            return (
              <>
                <div className={classNames(style.news, style.news__awards)}>
                  {results.map((el) => {
                    return (
                      <AwardsCard
                        key={el.id}
                        name={el.name}
                        date={el.active_from}
                        image={el.preview_picture}
                      />
                    )
                  })}
                </div>
                {status === dataStates.loading ? <BlockSpinner /> : undefined}
                {isNext
                  ? (
                    <Button disabled={status === dataStates.loading} onClick={showMore} size='large' wide outline>
                      Показать еще
                    </Button>
                    )
                  : undefined}
              </>
            )
          }}
        </FetcherList>
      </Container>
    </Section>
  )
}

export default AwardsSection
